'use client';

import { type Cookiebot } from '@/lib/cookiebot/types';
import './styles.css';

type Props = {
  cookiebot: Cookiebot | null;
};

// When using the Cookiebot pop-up template, we can't stop it from showing
// automatically except by using !important in CSS. This component hides and
// shows the Cookiebot pop-up as needed.
export const CookiebotHandler = (props: Props): null => {
  const { cookiebot } = props;

  const cookiebotElement = cookiebot?.dialog?.DOM;

  if (cookiebotElement) {
    if (cookiebot?.dialog?.visible) {
      cookiebotElement.classList.add('ih-active');
    } else {
      cookiebotElement.classList.remove('ih-active');
    }
  }

  return null;
};
